import { Form, Input, message, Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import { isTrackingNumber } from "../../../../utils/BarCodeUtil";
import { useTranslation } from 'react-i18next';
interface RemoveFromConsolidationModalProps {
  visible: boolean;
  disabled?: boolean;
  onOk: (trackingNumbers: string[]) => void;
  onCancel: () => void;
}

const { TextArea } = Input;

const RemoveFromConsolidationModal: React.FC<RemoveFromConsolidationModalProps> = ({
  visible,
  disabled = false,
  onOk,
  onCancel
}) => {
  const [trackingInput, setTrackingInput] = useState<string>('');
  const { t } = useTranslation();
  useEffect(() => {
    setTrackingInput('');
  }, [visible]);

  const handleOk = () => {
    if (disabled) return; // 防止重复点击
    // 支持逗号、分号、空白符及回车换行分割运单号
    const trackingNumbers = trackingInput.split(/[\n\r\s,;]+/).filter(Boolean);
    if (trackingNumbers.length === 0){
      message.error(t('wms.baggingTask.messages.pleaseEnterTheTrackingNumber'))
      return
    }
    const invalid = trackingNumbers.find(tn => !isTrackingNumber(tn));
    if (invalid) {
      message.error(`${invalid} ${t('wms.baggingTask.messages.isWrong,PleaseCheckFormat')}`);
      return;
    }
    onOk(trackingNumbers);
  };

  return (
    <Modal
      visible={visible}
      onOk={handleOk}
      onCancel={onCancel}
      okText={t('components.button.ok')}
      cancelText={t('components.button.cancel')}
      title={t('wms.baggingTask.buttons.moveOutOfBaggingTask')}
      width={600}
      destroyOnClose
      okButtonProps={{ disabled }}
    >
      <Form layout="vertical">
        <Form.Item label={t('wms.baggingTask.filters.trk')}>
          <TextArea
            rows={6}
            placeholder={t('wms.baggingTask.placeholders.trk') || ''}
            value={trackingInput}
            onChange={e => setTrackingInput(e.target.value)}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default RemoveFromConsolidationModal; 